(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["formula-cards-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(vp) {
    if (vp.dataset.fcsReady) return;
    vp.dataset.fcsReady = '1';
    var row = vp.querySelector('.formula-cards-section__row');
    if (!row) return;
    var prev = vp.querySelector('.formula-cards-section__arrow--prev');
    var next = vp.querySelector('.formula-cards-section__arrow--next');
    var cards = Array.prototype.slice.call(row.querySelectorAll('.formula-cards-section__card'));
    var dt = vp.getAttribute('data-fcs-layout') || 'carousel';
    var m = vp.getAttribute('data-fcs-layout-m') || dt;
    var active = 0;
    var curMode = null;
    var dotsWrap = vp.parentNode ? vp.parentNode.querySelector('[data-fcs-dots]') : null;
    var barTrack = dotsWrap ? dotsWrap.querySelector('[data-fcs-bar-track]') : null;
    var barThumb = dotsWrap ? dotsWrap.querySelector('[data-fcs-bar-thumb]') : null;
    var BAR_MIN = 24;
    // Thumb width = visible fraction of the row; position = scroll progress.
    // Computed in px so the thumb sits flush-left at start and flush-right at end.
    function updateBar() {
      if (!barTrack || !barThumb) return;
      var trackW = barTrack.clientWidth;
      if (trackW <= 0) return;
      if (mode() === 'stack') {
        var nn = cards.length || 1;
        var tws = Math.max(BAR_MIN, trackW / nn);
        barThumb.style.width = tws + 'px';
        barThumb.style.left = (nn > 1 ? (active / (nn - 1)) * (trackW - tws) : 0) + 'px';
        return;
      }
      var sw = row.scrollWidth, cw = row.clientWidth, max = sw - cw;
      var ratio = sw > 0 ? cw / sw : 1;
      var tw = Math.max(BAR_MIN, Math.min(trackW, ratio * trackW));
      var prog = max > 1 ? Math.max(0, Math.min(1, row.scrollLeft / max)) : 0;
      barThumb.style.width = tw + 'px';
      barThumb.style.left = (prog * (trackW - tw)) + 'px';
    }

    function mode() { return window.innerWidth >= 750 ? dt : m; }
    function n(attr, def) { var v = parseFloat(vp.getAttribute(attr)); return isNaN(v) ? def : v; }
    function stackCfg() {
      var mobile = window.innerWidth < 750;
      return {
        offset: mobile ? n('data-fcs-stack-offset-m', 28) : n('data-fcs-stack-offset', 48),
        yoff: n('data-fcs-stack-yoff', 0),
        step: n('data-fcs-stack-step', 7) / 100,
        max: n('data-fcs-stack-max', 2)
      };
    }

    function setLayoutClass(md) {
      row.classList.remove('is-grid', 'is-stack');
      if (md === 'grid') row.classList.add('is-grid');
      else if (md === 'stack') row.classList.add('is-stack');
    }
    function clearCardStyles() {
      row.style.height = '';
      cards.forEach(function (c) {
        c.style.transform = ''; c.style.opacity = ''; c.style.zIndex = '';
        c.style.pointerEvents = ''; c.classList.remove('is-active');
      });
    }

    function stackSize() {
      var c = stackCfg(), h = 0;
      cards.forEach(function (card) { if (card.offsetHeight > h) h = card.offsetHeight; });
      row.style.height = (h + Math.abs(c.yoff) * c.max + 12) + 'px';
    }
    function stackRender() {
      var c = stackCfg();
      cards.forEach(function (card, i) {
        var pos = i - active, ap = Math.abs(pos);
        var x = pos * c.offset, y = ap * c.yoff, s = Math.max(0.4, 1 - ap * c.step);
        card.style.transform = 'translate(calc(-50% + ' + x + 'px), ' + y + 'px) scale(' + s + ')';
        card.style.zIndex = String(100 - ap);
        var vis = ap <= c.max;
        card.style.opacity = vis ? String(Math.max(0, 1 - ap * 0.32)) : '0';
        card.style.pointerEvents = vis ? 'auto' : 'none';
        card.classList.toggle('is-active', pos === 0);
      });
      if (prev) prev.classList.toggle('is-hidden', active <= 0);
      if (next) next.classList.toggle('is-hidden', active >= cards.length - 1);
      updateBar();
    }
    function setActive(i) { active = Math.max(0, Math.min(cards.length - 1, i)); stackRender(); }

    function carStep() {
      var card = cards[0];
      if (!card) return Math.round(row.clientWidth * 0.85);
      var styles = getComputedStyle(row);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function carUpdate() {
      var max = row.scrollWidth - row.clientWidth - 1;
      row.classList.toggle('is-scrolled', row.scrollLeft > 2);
      row.classList.toggle('is-end', row.scrollLeft >= max - 2);
      if (!prev || !next) return;
      prev.classList.toggle('is-hidden', row.scrollLeft <= 0);
      next.classList.toggle('is-hidden', row.scrollLeft >= max);
    }

    function refresh() {
      var md = mode();
      if (md !== curMode) { curMode = md; setLayoutClass(md); clearCardStyles(); }
      if (dotsWrap) dotsWrap.style.display = (md === 'grid') ? 'none' : '';
      if (md === 'stack') { stackSize(); stackRender(); }
      else if (md === 'carousel') { carUpdate(); updateBar(); }
    }

    if (prev) prev.addEventListener('click', function () {
      var md = mode();
      if (md === 'stack') setActive(active - 1);
      else if (md === 'carousel') row.scrollBy({ left: -carStep(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      var md = mode();
      if (md === 'stack') setActive(active + 1);
      else if (md === 'carousel') row.scrollBy({ left: carStep(), behavior: 'smooth' });
    });

    if (barTrack) {
      var barDown = false;
      function barScrub(clientX) {
        var rect = barTrack.getBoundingClientRect();
        var tw = barThumb ? barThumb.offsetWidth : 0;
        var leftMax = rect.width - tw;
        var prog = leftMax > 0 ? Math.max(0, Math.min(1, (clientX - rect.left - tw / 2) / leftMax)) : 0;
        if (mode() === 'stack') { setActive(Math.round(prog * (cards.length - 1))); }
        else if (mode() === 'carousel') { row.scrollLeft = prog * (row.scrollWidth - row.clientWidth); updateBar(); }
      }
      barTrack.addEventListener('pointerdown', function (e) {
        if (mode() === 'grid') return;
        barDown = true; barScrub(e.clientX); e.preventDefault();
        try { barTrack.setPointerCapture(e.pointerId); } catch (err) {}
      });
      barTrack.addEventListener('pointermove', function (e) { if (barDown) barScrub(e.clientX); });
      function barEnd(e) { barDown = false; try { barTrack.releasePointerCapture(e.pointerId); } catch (err) {} }
      barTrack.addEventListener('pointerup', barEnd);
      barTrack.addEventListener('pointercancel', barEnd);
    }

    row.addEventListener('scroll', function () { if (mode() === 'carousel') { carUpdate(); updateBar(); } }, { passive: true });

    var down = false, sx = 0, sl = 0, moved = false;
    row.addEventListener('pointerdown', function (e) {
      var md = mode();
      if (md === 'grid') return;
      if (md === 'carousel' && e.pointerType === 'touch') return;
      down = true; moved = false; sx = e.clientX; sl = row.scrollLeft;
      if (md === 'carousel') row.classList.add('is-dragging');
      try { row.setPointerCapture(e.pointerId); } catch (err) {}
    });
    row.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 3) moved = true;
      if (mode() === 'carousel') row.scrollLeft = sl - dx;
    });
    function endDrag(e) {
      if (!down) return; down = false;
      var md = mode();
      try { row.releasePointerCapture(e.pointerId); } catch (err) {}
      if (md === 'carousel') row.classList.remove('is-dragging');
      else if (md === 'stack') {
        var dx = e.clientX - sx;
        if (dx <= -40) setActive(active + 1);
        else if (dx >= 40) setActive(active - 1);
      }
    }
    row.addEventListener('pointerup', endDrag);
    row.addEventListener('pointercancel', function () { down = false; row.classList.remove('is-dragging'); });

    row.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; return; }
      if (mode() !== 'stack') return;
      var t = e.target.closest && e.target.closest('.formula-cards-section__card');
      if (!t) return;
      var idx = cards.indexOf(t);
      if (idx > -1 && idx !== active) { e.preventDefault(); setActive(idx); }
    }, true);

    row._fcsFocus = function (card) {
      if (mode() === 'stack') { var idx = cards.indexOf(card); if (idx > -1) setActive(idx); }
      else if (card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    };

    window.addEventListener('resize', refresh);
    cards.forEach(function (card) {
      card.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', function () { if (mode() === 'stack') { stackSize(); stackRender(); } });
      });
    });

    refresh();
  }

  function setupAll(root) {
    (root || document).querySelectorAll('.formula-cards-section__viewport').forEach(setup);
  }

  if (document.readyState !== 'loading') setupAll();
  else document.addEventListener('DOMContentLoaded', function () { setupAll(); });

  document.addEventListener('shopify:section:load', function (e) { setupAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest && e.target.closest('.formula-cards-section__card');
    if (!card) return;
    var row = card.closest('.formula-cards-section__row');
    if (row && row._fcsFocus) row._fcsFocus(card);
    else if (card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      // Re-measure on resize and after fonts/images settle so --header-height stays accurate.
      this.boundSetHeaderHeight = this.setHeaderHeight.bind(this);
      window.addEventListener('resize', this.boundSetHeaderHeight);
      window.addEventListener('load', this.boundSetHeaderHeight);

      this.createObserver();
    }

    setHeaderHeight() {
      const root = document.documentElement;
      const headerH = this.header.offsetHeight;
      root.style.setProperty('--header-height', `${headerH}px`);

      // Sum any preceding shopify-sections in the same header group (e.g. announcement bar)
      // so the hero / page can clear the full visual header stack, not just the nav bar.
      let groupH = headerH;
      let prev = this.header.previousElementSibling;
      while (prev && prev.classList && prev.classList.contains('shopify-section')) {
        groupH += prev.offsetHeight;
        prev = prev.previousElementSibling;
      }
      root.style.setProperty('--header-group-height', `${groupH}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.boundSetHeaderHeight) {
        window.removeEventListener('resize', this.boundSetHeaderHeight);
        window.removeEventListener('load', this.boundSetHeaderHeight);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Add minimum scroll delta threshold to reduce flickering
      const scrollDelta = Math.abs(scrollTop - this.currentScrollTop);
      if (scrollDelta < 5) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      const root = document.documentElement;
      const headerH = this.header.offsetHeight;
      root.style.setProperty('--header-height', `${headerH}px`);

      // Sum any preceding shopify-sections in the same header group (e.g. announcement bar)
      // so the hero / page can clear the full visual header stack, not just the nav bar.
      let groupH = headerH;
      let prev = this.header.previousElementSibling;
      while (prev && prev.classList && prev.classList.contains('shopify-section')) {
        groupH += prev.offsetHeight;
        prev = prev.previousElementSibling;
      }
      root.style.setProperty('--header-group-height', `${groupH}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
